/* global axios */
import ApiClient from './ApiClient';

class EmpresasAPI extends ApiClient {
  constructor() {
    super('empresas', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  search(query = '', page = 1) {
    return this.get({ q: query, page });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  conversations(id) {
    return axios.get(`${this.url}/${id}/conversations`);
  }

  create(empresaData) {
    return axios.post(this.url, { empresa: empresaData });
  }

  update(id, empresaData) {
    return axios.patch(`${this.url}/${id}`, { empresa: empresaData });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new EmpresasAPI();
